import { useMutation } from '@tanstack/react-query';
import { accountApi, type ChangePasswordRequest } from '../api/account-api';

export function useChangePasswordMutation() {
  return useMutation({
    mutationFn: (body: ChangePasswordRequest) => accountApi.changePassword(body),
  });
}
